import { Field as ChakraField } from '@chakra-ui/react'

export default function Field({ label, error, helper, children, ...props }){
    return(
    <ChakraField.Root invalid={!!error} required={props?.required}>
        { label && <ChakraField.Label>{label} <ChakraField.RequiredIndicator /></ChakraField.Label>}
        { children }
        <ChakraField.ErrorText children={error} />
        <ChakraField.HelperText children={helper} />
    </ChakraField.Root>
    )
}